import request from '@/utils/request'

// 新增学习方案
export function addAmcStudyScheme(data) {
  return request({
    url: '/amc-study-schemes',
    method: 'post',
    data
  })
}

// 根据ID删除学习方案
export function deleteAmcStudyScheme(id) {
  return request({
    url: `/amc-study-schemes/${id}`,
    method: 'delete'
  })
}

// 批量删除学习方案
export function batchDeleteAmcStudySchemes(ids) {
  return request({
    url: '/amc-study-schemes/batch',
    method: 'delete',
    data: ids
  })
}

// 更新学习方案
export function updateAmcStudyScheme(data) {
  return request({
    url: '/amc-study-schemes',
    method: 'put',
    data
  })
}

// 根据ID查询学习方案
export function getAmcStudySchemeById(id) {
  return request({
    url: `/amc-study-schemes/${id}`,
    method: 'get'
  })
}

// 分页查询学习方案
// params: { pageNum, pageSize, userId?, amcRepo? }
export function getAmcStudySchemesPage(params) {
  return request({
    url: '/amc-study-schemes/page',
    method: 'get',
    params
  })
}

// 根据用户ID查询学习方案列表
export function listAmcStudySchemesByUser(userId) {
  return request({
    url: `/amc-study-schemes/user/${userId}`,
    method: 'get'
  })
}

// 按深度比例生成题目清单并写入学习方案
// 后端为 @RequestParam 形式，使用 params 传参
export function generateAmcStudyScheme(userId, amcRepo, depthSnapshot) {
  return request({
    url: '/amc-study-schemes/generate',
    method: 'post',
    params: { userId, amcRepo, depthSnapshot }
  })
}

// 将题目ID添加到已完成列表
export function addFinishedQuestion(userId, amcRepo, questionId) {
  return request({
    url: '/amc-study-schemes/addFinished',
    method: 'post',
    params: { userId, amcRepo, questionId }
  })
}

// 批量将题目ID添加到已完成列表
export function addFinishedQuestionBatch(userId, amcRepo, questionIds) {
  return request({
    url: '/amc-study-schemes/addFinishedBatch',
    method: 'post',
    params: { userId, amcRepo },
    data: questionIds
  })
}
